// app/frontend/entrypoints/public/plugins/i18n.js
import { createI18n } from 'vue-i18n'
import messages from '../locales/index.js'   // 👈 обязательно index.js

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: localStorage.getItem('locale') || 'ru',
  fallbackLocale: 'ru',
  messages
})

// ✅ делаем i18n доступным глобально (для router / console)
if (typeof window !== 'undefined') {
  window.i18n = i18n
}
export default i18n
